import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { EventRegistrationInfoController } from '../../models/event/event.model';


@Pipe({
  name: 'EventRegistrationFilter'
})

@Injectable()
export class EventRegistrationPipe implements PipeTransform {

  transform(value: EventRegistrationInfoController[], filter: string): EventRegistrationInfoController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: EventRegistrationInfoController) =>
      app.ParticipantName != null && app.ParticipantName.toLocaleLowerCase().indexOf(filter) != -1

      || app.ContactNo != null && app.ContactNo.toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }

}
